import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';
import { WjGridTransposedModule } from '@grapecity/wijmo.angular2.grid.transposed';

import { KYMW1200Component } from './kymw1200.component';
import { KYMW1203Module } from '../kymw1203/kymw1203.module';
import { KYMW1202Module } from '../kymw1202/kymw1202.module';
import { KYMW1100Module } from '../../kymw11/kymw1100/kymw1100.module';

import { GetBuyerSelectItemsService } from './api-services/get-buyer-select-items.service';
import { GetCycleDispConditionService } from './api-services/get-cycle-disp-condition.service';
import { GetCycleItemInfoService } from './api-services/get-cycle-item-info.service';
import { GetCycleMediumSelectItemsService } from './api-services/get-cycle-medium-select-items.service';
import { GetCycleSummaryDiffService } from './api-services/get-cycle-summary-diff.service';
import { GetCycleSummaryService } from './api-services/get-cycle-summary.service';
import { GetNonFixedOrderListService } from './api-services/get-non-fixed-order-list.service';
import { GetOtherMediumsService } from './api-services/get-other-mediums.service';
import { RegistCycleDispConditionService } from './api-services/regist-cycle-disp-condition.service';
import { RegistCycleItemInfoService } from './api-services/regist-cycle-item-info.service';
import { RegistCycleSortService } from './api-services/regist-cycle-sort.service';
import { RegistWkResultListService } from './api-services/regist-wk-result-list.service';
import { GetCodeListService } from '../../../commons/kymw02/api-services/get-code-list.service';
import { GetOrderListService } from '../../../commons/kymw02/api-services/get-order-list.service';
import { GetCoopListService } from '../../../commons/kymw02/api-services/get-coop-list.service';
import { GetBuyerCodeForAgentService } from './api-services/get-buyer-code-for-agent.service';
import { OutputCycleItemInfoService } from './api-services/output-cycle-item-info.service';
import { GetStaffBuyerSelectItemsService } from './api-services/get-staff-buyer-select-items.service';
import { KYMW1204Module } from '../kymw1204/kymw1204.module';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { KYMW1205Module } from '../kymw1205/kymw1205.module';

/**
 * サイクル設定画面 モジュール設定クラス
 *
 * @export KYMW1200Module
 * @class KYMW1200Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjGridFilterModule,
    WjGridTransposedModule,
    KYMW1202Module,
    KYMW1203Module,
    KYMW1100Module,
    KYMW1204Module,
    KYMW1205Module,
    WjNavModule,
  ],
  declarations: [KYMW1200Component],
  providers: [
    GetBuyerSelectItemsService,
    GetCycleDispConditionService,
    GetCycleItemInfoService,
    GetCycleMediumSelectItemsService,
    GetCycleSummaryDiffService,
    GetCycleSummaryService,
    GetNonFixedOrderListService,
    GetOtherMediumsService,
    RegistCycleDispConditionService,
    RegistCycleItemInfoService,
    RegistCycleSortService,
    RegistWkResultListService,
    GetCodeListService,
    GetOrderListService,
    GetCoopListService,
    GetBuyerCodeForAgentService,
    OutputCycleItemInfoService,
    GetStaffBuyerSelectItemsService,
  ],
})
export class KYMW1200Module {}
